module.exports = __webpack_public_path__ + "img/f2f1183.jpg";